import {
	UPLOAD_LIBRARY_MEDIA,
	DELETE_LIBRARY,
	UPDATE_LIBRARY,
	FETCH_LIBRARY,
	CLEAR_LIBRARY,
	UPDATE_CHILD_LIBRARY,
	ADD_CHILD_LIBRARY,
	DELETE_CHILD_LIBRARY,
	ADD_GROUPS_TO_LIBRARY,
	REMOVE_GROUPS_FROM_LIBRARY,
} from '../actions/actionTypes';

const preState = {
	media: { nodes: [] },
	libraries: [],
	groups: [],
};

const libraryReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, library, media, libraryID, groups, groupIDs } = action;

	switch (type) {
		case FETCH_LIBRARY:
			return { ...stateDup, ...library };

		case UPDATE_LIBRARY:
			return { ...stateDup, ...library };

		case DELETE_LIBRARY:
			return {};

		case UPLOAD_LIBRARY_MEDIA:
			const medias = stateDup.media.nodes;

			return { ...stateDup, media: { nodes: [media, ...medias] } };
		case CLEAR_LIBRARY:
			return {};

		case ADD_CHILD_LIBRARY:
			stateDup.libraries = [...stateDup.libraries, library];
			return { ...stateDup };

		case UPDATE_CHILD_LIBRARY:
			stateDup.libraries = stateDup.libraries.map(l =>
				l.id === library.id ? { ...l, ...library } : l
			);
			return { ...stateDup };

		case DELETE_CHILD_LIBRARY:
			stateDup.libraries = stateDup.libraries.filter(l => l.id !== libraryID);
			return { ...stateDup };

		case ADD_GROUPS_TO_LIBRARY:
			stateDup.groups = [...stateDup.groups, ...groups];
			return { ...stateDup };

		case REMOVE_GROUPS_FROM_LIBRARY:
			stateDup.groups = stateDup.groups.filter(group => !groupIDs.includes(group.id));
			return { ...stateDup };

		default:
			return stateDup;
	}
};

export default libraryReducer;
